import React from 'react';
import ReactDOM from 'react-dom/client';
import 'sweetalert2/dist/sweetalert2.min.css';
import './index.css';
import App from './App';

const SKIP_INPUT_TYPES = new Set([
  'hidden',
  'checkbox',
  'radio',
  'submit',
  'button',
  'file',
  'range',
  'color',
  'image',
  'reset',
]);

function blockBrowserAutofill(node) {
  if (!node || node.nodeType !== 1) return;
  const elements = [];
  if (node.matches?.('input, textarea, form')) elements.push(node);
  node.querySelectorAll?.('input, textarea, form').forEach((el) => elements.push(el));
  elements.forEach((el) => {
    if (el.tagName === 'FORM') {
      el.setAttribute('autocomplete', 'off');
      return;
    }
    if (el.tagName === 'INPUT') {
      const type = (el.getAttribute('type') || 'text').toLowerCase();
      if (SKIP_INPUT_TYPES.has(type)) return;
      el.setAttribute('autocomplete', type === 'password' ? 'new-password' : 'blocked');
      return;
    }
    el.setAttribute('autocomplete', 'blocked');
  });
}

blockBrowserAutofill(document);
new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => blockBrowserAutofill(node));
  });
}).observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('focusin', (event) => blockBrowserAutofill(event.target), true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
